module.exports = __webpack_public_path__ + "img/avatar0.7ac5f7ea.png";